import { Directory, Encoding, Filesystem, FilesystemEncoding } from '@capacitor/filesystem';
import { FileOpener } from '@capawesome-team/capacitor-file-opener';

const openContract = async (base64: string) => {
  const currentDate = new Date().toLocaleString().replace(/[,:\s\/]/g, '-');
  const fileName = `contract-${currentDate}.pdf`;
  const { uri } = await Filesystem.writeFile({
    path: fileName,
    data: base64,
    directory: Directory.Documents,
  });
  await FileOpener.openFile({
    path: uri,
  });
};

const openSettlementCsv = async (file: string, date?: string) => {
  const currentDate = Date.now().toLocaleString().replaceAll('.', '');
  const fileName = `settlements${date && `-${date}`}--${currentDate}.csv`;
  const { uri } = await Filesystem.writeFile({
    path: fileName,
    data: file,
    directory: Directory.Documents,
    encoding: Encoding.UTF8
  });
  await FileOpener.openFile({
    path: uri,
  });
};

export const fileOpenerService = {
  openContract,
  openSettlementCsv
};
